export { default } from "./FrontPage";



// WEBPACK FOOTER //
// ./src/containers/Private/pages/FrontPage/index.js